<template>
  <v-footer v-if="uiTexts && uiConfig">
    <v-col class="text-center">
      <span v-html="uiConfig.aboutText"></span>
      <br />
      <br />
      <span v-html="uiConfig.poweredByText"></span>
    </v-col>
  </v-footer>
</template>
<script>
export default {
  props: {
    uiTexts: Object,
    uiConfig: Object,
  },
  created() {
    //console.log(this);
  },
};
</script>
<style></style>
